<script setup>
import {ref} from "vue";
import { useNotificationStore } from '@/stores/NotificationStore.js'

const notificationStore = useNotificationStore()
const emit = defineEmits(['cancel', 'reload'])

const props = defineProps({
    listId: {
        type: Number,
        required: false,
        default: null,
    },
    listName: {
        type: String,
        required: true,
    },
    templateTasks: {
        type: Array,
        required: true,
    }
})

const listName = ref(props.listName)

const cancel = () => {
    emit('cancel')
}

const storeOrUpdate = () => {
    if (props.listId) {
        updateList()
    } else {
        storeList()
    }
}

const storeList = async() => {
    const res = await axios.post(route('api.task-list-template.store'), {
        id: props.listId,
        name: listName.value,
        tasks: props.templateTasks,
    })

    emit('reload')
    if (res.data.success) {
        notificationStore.addNotification({
            type: 'success',
            title: 'Template created',
            message: listName.value,
            dismissAfter: 5000,
        })
    }
}

const updateList = async() => {
    const res = await axios.put(route('api.task-list-template.update', props.listId), {
        name: listName.value,
        tasks: props.templateTasks,
    })

    emit('reload')
    if (res.data.success) {
        notificationStore.addNotification({
            type: 'success',
            title: 'Template updated',
            message: listName.value,
            dismissAfter: 5000,
        })
    }
}

const deleteTemplate = async() => {
    if (! props.listId) {
        return
    }

    const res = await axios.delete(route('api.task-list-template.destroy', props.listId))

    if (res.data.success) {
        notificationStore.addNotification({
            type: 'success',
            title: 'Template deleted',
            message: listName.value,
            dismissAfter: 5000,
        })
        emit('reload')
    }
}

</script>
<template>
    <div>
        <div class="container w-full mx-auto md:sticky top-2 z-topbar mb-8">
            <frosted-bar>
                <div class="flex items-center justify-between">
                    <div>
                        <h1>
                            {{ props.listId ? 'Edit template' : 'Create template'}}
                        </h1>
                    </div>
                    <div class="flex justify-end space-x-4">
                        <button-with-confirmation
                            v-if="props.listId"
                            confirm-type="danger"
                            confirm-text="Are you sure you want to delete this template?"
                            confirm-button-label="Delete"
                            abort-button-label="Cancel"
                            @confirmed="deleteTemplate"
                        >
                            Delete
                        </button-with-confirmation>

                        <button-secondary
                            @click="cancel"
                        >
                            Cancel
                        </button-secondary>

                        <button-success
                            @click="storeOrUpdate"
                        >
                            Save
                        </button-success>
                    </div>
                </div>
                <template #navigation>
                    <a
                        :href="route('task-list-template.index')"
                        class="mf-link text-xs"
                    >
                        &laquo; All templates
                    </a>
                </template>
            </frosted-bar>
        </div>


        <list-basic>
            <template #header>
                <div>
                    <input-text
                        label="Task list name"
                        autofocus
                        v-model:content="listName"
                    ></input-text>
                </div>
            </template>
            <list-basic-item
                v-for="(item, i) in templateTasks"
                :key="item.key"
            >
                <task-template-task
                    :task="item"
                />
            </list-basic-item>
        </list-basic>
</div>
</template>
